import e from "../managers/braze-instance.js";
export function getUser() {
  if (e.rr()) return e.gr();
}
